import React, { useEffect } from "react";
import "./Popular-Projects.css";
import Aos from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";
const PopularProjects = () => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);
  return (
    <div className="popular-projects">
      <div className="popular-project-head-div">
        
        {/* RRz customX */}

        <div data-aos="flip-left" className="row  com-a">
          <div data-aos="fade-up" className="col-md-5 com-b">
            <img
              class="popular-projects-img"
              src="https://i.ibb.co/c2k1ZH0/Screenshot-29-1-1.png"
              alt="home page"
            />
          </div>
          <div className="col-md-6 com-b">
            <h3 data-aos="slide-down">RoadRiderz Custom Xpess</h3>
            <div data-aos="slide-up">
              <p>
                This is Customize motor bike related website, user can buy &
                remove product also implement Stripe payment Gateway system
                (Stripe).
              </p>
              <p>
                Using technologies are ReactJS, NodeJS, ExpressJS, MongoDB,
                Firebase, Heroku.
              </p>
              <p>
                A fully functional full-stack web app basses on MERN stack. It
                has admin panel.
              </p>
              <p>This Site fully responsive for large and small device.</p>
            </div>
            <Link className="aboutMe-button" to="/RoadRiderzCustomX">
              <b>More Details</b>
            </Link>
            <a
              target="_blank"
              className="resume"
              href="https://road-riderz-custom-express.web.app/"
            >
              <b>Live Site</b>
            </a>
          </div>
        </div>
        
        {/* Bangal Tourism */}
        <div data-aos="flip-left" className="row  com-a">
          <div data-aos="fade-up" className="col-md-5 com-b">
            <img
              class="popular-projects-img"
              src="https://i.ibb.co/r3MWGyD/homeBT.png"
              alt="home page"
            />
          </div>
          <div className="col-md-6 com-b">
            <h3 data-aos="slide-down">Bangal Tourism</h3>
            <div data-aos="slide-up">
              <p>
              We are highlighting our tourism industry with attractive functional website.
              </p>
              <p>
              Bangal Tourism has two role, one is user role and second is admin role. When admin logged in, UI render admin Control Pannel, and when user logged in, UI render user control system.
              </p>
              <p>
              User can rate Bangal Tourism and instantly update in home page of UI.
              </p>
              <p>Using NodeJS and ExpressJs for server side, and using no sql DB like MongoDB</p>
            </div>
            <Link className="aboutMe-button" to="/BangalTourism">
              <b>More Details</b>
            </Link>
            <a
              target="_blank"
              className="resume"
              href="https://bangal-tourism.web.app/"
            >
              <b>Live Site</b>
            </a>
          </div>
        </div>

        <div data-aos="flip-left" className="row  com-a">
          <div data-aos="fade-up" className="col-md-5 com-b">
            <img
              class="popular-projects-img"
              src="https://i.ibb.co/d4gYKvm/jinni-1.png"
              alt="home page"
            />
          </div>
          <div className="col-md-6 com-b">
            <h3 data-aos="slide-down">Jinni Relocation</h3>
            <div data-aos="slide-up">
              <p>
                Jinni Relocation is a relocation platform make relocation
                service more comfortable and easier.
              </p>
              <p>
                Providing Transports like truck, pickup van, covered van, lorry.
              </p>
              <p>
                Using react router version 6, Animation on scroll (AOS),Axios
              </p>
              <p>This site create with MERN Stack technology</p>
            </div>
            <Link className="aboutMe-button" to="/JinniRelocation">
              <b>More Details</b>
            </Link>
            <a
              target="_blank"
              className="resume"
              href="https://jinni-relocation.firebaseapp.com/"
            >
              <b>Live Site</b>
            </a>
          </div>
        </div>


        <div data-aos="flip-left" className="row com-a">
          <div data-aos="fade-up" className="col-md-5 com-b">
            <img
              class="popular-projects-img"
              src="https://i.ibb.co/0XN0KpC/Screenshot-73-1.png"
              alt="front-page-home page"
            />
          </div>
          <div className="col-md-6 com-b">
            <h3 data-aos="slide-down">Virtual Shop </h3>
            <div data-aos="slide-up">
              <p>
                User can book their selected tour package and vew their order
                detail on My Order page.
              </p>
              <p>
                Happy is online resort booking website with offering best price.
              </p>
              <p>Implement CRUD operation and using MERN.</p>
              <p>This site all device responsive</p>
            </div>
            <Link className="aboutMe-button" to="/VirtualShop">
              <b>More Details</b>
            </Link>
            <a
              target="_blank"
              className="resume"
              href="https://virtual-shop-bd.netlify.app/"
            >
              <b>Live Site</b>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopularProjects;
